import Box from '@mui/material/Box'
import noImageToShow from '../../assets/Noimage.png'

const PreviewImageSlider = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '8px',
      display: 'flex',
      height: '300px',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      width: '100%'
    }}
  >
    <Box
      component='img'
      alt='No Content Available'
      src={noImageToShow}
      sx={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
    <Box
      sx={{
        backgroundColor: 'rgba(0,0,0,0.5)',
        borderRadius: '4px',
        bottom: '10px',
        color: '#fff',
        fontFamily: 'Lato, sans-serif',
        fontSize: '14px',
        padding: '2px 8px',
        position: 'absolute'
      }}
    >
      Preview Image Slider Placeholder
    </Box>
  </Box>
)

export default PreviewImageSlider
